import { Pagination } from 'design-system-web';

export default Pagination;
